import Vue from 'vue'
import {ActionTree, MutationTree} from 'vuex'
import {RootState} from '@/store/types'

import {Show} from '@/store/modules/lib'
import axios from 'axios';
import alerts from '@/store/modules/alerts';

export interface Tickets {
  id: string,
  title: string,
  description: string,
  price: string,
  start: string,
  end: string,
  promo: Array<String>,
  visibility: boolean,
  active: boolean,
}

export interface State {
  tickets: Tickets[],
  services: Tickets[],
  promo: any[],
  trade: any[],
  conference: any[],
  day_tickets: any[],
  statistics_common: any,
}


const defaultState: State = {
  tickets: [
    {
      id: 't1',
      title: 'Day ticket',
      description: 'Your personal ticket valid for one show day',
      price: '17',
      start: '09.01.2023 10:00',
      end: 'end',
      promo: ['NEW_uj67'],
      visibility: false,
      active: false,
    },
    {
      id: 't2',
      title: 'Day ticket group',
      description: 'Personal tickets valid not more then 10 visitors',
      price: '27',
      start: '09.01.2023 10:00',
      end: 'end',
      promo: ['GHGFH4GV', 'FDHYNJMG', 'NEW_uj67'],
      visibility: true,
      active: true,
    },
    {
      id: 't3',
      title: 'Specialist Conference ticket',
      description: 'Your personal ticket valid to visit Specialist Conference',
      price: '52',
      start: '09.01.2023 10:00',
      end: '01.03.2023 19:00',
      promo: ['VIVA_990'],
      visibility: true,
      active: true,
    },
    {
      id: 't4',
      title: 'Digital Trade fair+Conference ticket',
      description: 'Your personal ticket valid to visit Specialist Conference and to access Digital Trade fair',
      price: '55',
      start: '09.01.2023 10:00',
      end: 'start',
      promo: [],
      visibility: true,
      active: true,
    },
    {
      id: 't5',
      title: 'Reduced day ticket',
      description: 'Your personal reduced ticket for one fair day',
      price: '10',
      start: '09.01.2023 10:00',
      end: 'end',
      promo: [],
      visibility: true,
      active: true,
    },
    {
      id: 't6',
      title: 'Multiday ticket',
      description: 'Your personal ticket for all days of trade fair',
      price: '35',
      start: '09.01.2023 10:00',
      end: 'start',
      promo: ['FDHYNJMG', 'FDHYNJMG', 'FDHYNJMG'],
      visibility: true,
      active: true,
    },
    {
      id: 't7',
      title: 'Lucky hours ticket',
      description: 'Your personal day ticket valid after 14.00 for one trade fair day',
      price: '55',
      start: '20.02.2023 10:00',
      end: 'end',
      promo: [],
      visibility: false,
      active: false,
    },
    {
      id: 't8',
      title: 'VIP ticket',
      description: 'VIP guests ticket valid for all days and all actions',
      price: '0',
      start: '09.01.2023 10:00',
      end: 'end',
      promo: [],
      visibility: false,
      active: true,
    },
  ],
  services: [
    {
      id: 's1',
      title: 'Wi-Fi',
      description: 'Access to Wi-Fi at the Trade Fair',
      price: '15',
      start: '09.01.2023 10:00',
      end: 'end',
      promo: ['FDHYNJMG', 'NEW_uj67'],
      visibility: true,
      active: true,
    },
    {
      id: 's2',
      title: 'Transfer',
      description: 'Transfer to the  Trade Fair location from the Airport',
      price: '15',
      start: '09.01.2023 10:00',
      end: 'end',
      promo: [],
      visibility: true,
      active: true,
    },
    {
      id: 's3',
      title: 'Ticket ensurance',
      description: 'Ticket ensurance from the partner',
      price: '15',
      start: '09.01.2023 10:00',
      end: 'end',
      promo: [],
      visibility: true,
      active: true,
    },
  ],
  promo: [
    {
      id: 'p1',
      title: 'Messe',
      isTooltip: true,
      type: 'Voucher',
      applyed: [],
      discount: '25%',
      start: '03.01.2023 10:00',
      end: '31.03.2023 19:00',
      quantity: '-',
      active: true,
    },
    {
      id: 'p2',
      title: 'Scripe',
      isTooltip: false,
      type: 'Voucher',
      applyed: ['All types'],
      discount: '50%',
      start: '09.01.2023 10:00',
      end: '31.03.2023 19:00',
      quantity: '-',
      active: true,
    },
    {
      id: 'p3',
      title: 'Tresto',
      isTooltip: false,
      type: 'Voucher',
      applyed: ['All types'],
      discount: '50%',
      start: '09.01.2023 10:00',
      end: '31.03.2023 19:00',
      quantity: '23',
      active: true,
    },
    {
      id: 'p4',
      title: 'NEW_uj67',
      isTooltip: false,
      type: 'Promo code',
      applyed: ['Day ticket'],
      discount: '15%',
      start: '09.01.2023 10:00',
      end: '01.03.2023 19:00',
      quantity: '-',
      active: true,
    },
    {
      id: 'p5',
      title: 'GHGFH4GV',
      isTooltip: false,
      type: 'Promo code',
      applyed: ['Day ticket group'],
      discount: '10%',
      start: '09.01.2023 10:00',
      end: '01.03.2023 19:00',
      quantity: '302/1000',
      active: true,
    },
    {
      id: 'p6',
      title: 'FDHYNJMG',
      isTooltip: false,
      type: 'Promo code',
      applyed: ['Multiday ticket'],
      discount: '15%',
      start: '09.01.2023 10:00',
      end: '28.02.2023 19:00',
      quantity: '120',
      active: true,
    },
    {
      id: 'p7',
      title: 'EARLY_US23',
      isTooltip: false,
      type: 'Promo code',
      applyed: ['Multiday ticket'],
      discount: '10%',
      start: '09.01.2023 10:00',
      end: '28.02.2023 19:00',
      quantity: '456',
      active: true,
    },
    {
      id: 'p8',
      title: 'EXPO_23',
      isTooltip: false,
      type: 'Promo code',
      applyed: ['Multiday ticket'],
      discount: '20%',
      start: '09.01.2023 10:00',
      end: '28.02.2023 19:00',
      quantity: '432/1000',
      active: true,
    },
    {
      id: 'p9',
      title: 'VIVA_990',
      isTooltip: false,
      type: 'Promo code',
      applyed: ['Specialist Conference ticket'],
      discount: '10%',
      start: '09.01.2023 10:00',
      end: '28.02.2023 19:00',
      quantity: '25/500',
      active: true,
    },
    {
      id: 'p10',
      title: 'JFJ_89',
      isTooltip: false,
      type: 'Promo code',
      applyed: ['Day ticket group'],
      discount: '15%',
      start: '09.01.2023 10:00',
      end: '31.03.2023 19:00',
      quantity: '78',
      active: true,
    },
    {
      id: 'p11',
      title: 'J57676K',
      isTooltip: false,
      type: 'Promo code',
      applyed: ['Day ticket group'],
      discount: '5%',
      start: '09.01.2023 10:00',
      end: 'end',
      quantity: '356',
      active: true,
    },
  ],
  trade: [
    {
      id: 't1',
      title: 'Day ticket',
      number: '60 729',
      revenue: '953 460€',
      max: '988',
      date: '20.02.2023',
      price: '15.7€',
      incomplete: '0',
      return: '0',
    },
    {
      id: 't2',
      title: 'Day ticket group',
      number: '7722',
      revenue: '170 864€',
      max: '515',
      date: '18.0.2023',
      price: '22.12€',
      incomplete: '1',
      return: '0',
    },
    {
      id: 't3',
      title: 'Reduced day ticket',
      number: '2012',
      revenue: '20 120€',
      max: '30',
      date: '02.02.2023',
      price: '10€',
      incomplete: '0',
      return: '0',
    },
    {
      id: 't4',
      title: 'Multiday ticket',
      number: '32340',
      revenue: '905 540€',
      max: '901',
      date: '19.02.2023',
      price: '27.35€',
      incomplete: '0',
      return: '1',
    },
    {
      id: 't5',
      title: 'VIP ticket',
      number: '0',
      revenue: '0',
      max: '28',
      date: '20.02.2023',
      price: '0',
      incomplete: '0',
      return: '0',
    },
  ],
  conference: [
    {
      id: 'c1',
      title: 'Specialist Conference ticket',
      number: '1500',
      revenue: '69 150€',
      max: '288',
      date: '20.02.2023',
      price: '46.10',
      incomplete: '0',
      return: '0',
    },
    {
      id: 'c2',
      title: 'Digital Trade fair+Conference ticket',
      number: '2567',
      revenue: '89 845€',
      max: '512',
      date: '14.02.2023',
      price: '35€',
      incomplete: '0',
      return: '0',
    },
  ],
  day_tickets: [
    {
      id: 'd1',
      name: 'John Smith',
      date: '09.01.2023 12:23',
      start: '17€',
      end: '14.45€',
      email: 'smith@gmail.com',
      registration: 10,
      method: 'Online',
    },
    {
      id: 'd2',
      name: 'Jane Farry',
      date: '09.01.2023 12:32',
      start: '17€',
      end: '17€',
      email: 'farry@gmail.com',
      registration: 50,
      method: 'Cash',
    },
    {
      id: 'd3',
      name: 'Mike Notherhaim',
      date: '09.01.2023 13:21',
      start: '17€',
      end: '14.45€',
      email: 'noth@gmail.com',
      registration: 100,
      method: 'Online',
    },
    {
      id: 'd4',
      name: 'Angelina Jones',
      date: '09.01.2023 14:23',
      start: '17€',
      end: '14.45€',
      email: 'jones_a@gmail.com',
      registration: 75,
      method: 'Online',
    },
    {
      id: 'd5',
      name: 'Andy Hopkins',
      date: '09.01.2023 14:25',
      start: '17€',
      end: '14.45€',
      email: 'Hopkins@gmail.com',
      registration: 100,
      method: 'Online',
    },
    {
      id: 'd6',
      name: 'Jane Dow',
      date: '09.01.2023 15:15',
      start: '17€',
      end: '14.45€',
      email: 'Dowj@gmail.com',
      registration: 100,
      method: 'Online',
    },
    {
      id: 'd7',
      name: 'Susan Dash',
      date: '09.01.2023 15:25',
      start: '17€',
      end: '14.45€',
      email: 'Dashs@gmail.com',
      registration: 100,
      method: 'Online',
    },
    {
      id: 'd8',
      name: 'Kate French',
      date: '09.01.2023 16:25',
      start: '17€',
      end: '14.45€',
      email: 'French@gmail.com',
      registration: 100,
      method: 'Online',
    },
    {
      id: 'd9',
      name: 'Addy Brunstorm',
      date: '09.01.2023 17:18',
      start: '17€',
      end: '14.45€',
      email: 'Brunstorm@gmail.com',
      registration: 100,
      method: 'Online',
    },
    {
      id: 'd10',
      name: 'Sew Pretty',
      date: '09.01.2023 18:19',
      start: '17€',
      end: '14.45€',
      email: 'prettyW@gmail.com',
      registration: 100,
      method: 'Online',
    },
    {
      id: 'd11',
      name: 'Candy Wane',
      date: '09.01.2023 19:20',
      start: '17€',
      end: '14.45€',
      email: 'wanec@gmail.com',
      registration: 100,
      method: 'Online',
    },
  ],
  statistics_common: {
    tickets: {
      all: '65250',
      today: '1232'
    },
    tickets_revenue: {
      all: '2210160',
      today: '72176'
    },
    service: {
      all: '21750',
      today: '435'
    },
    service_revenue: {
      all: '152250',
      today: '345'
    },
    refund: {
      all: '570',
      today: '0'
    },
    proceed: {
      all: '2361840'
    }
  }
};

const getters = {
  tickets: (state: State) => state.tickets,
  services: (state: State) => state.services,
  promo: (state: State) => state.promo,
  trade: (state: State) => state.trade,
  conference: (state: State) => state.conference,
  day_tickets: (state: State) => state.day_tickets,
  statistics_common: (state: State) => state.statistics_common,
}

const mutations: MutationTree<State> = {
  setTickets(state: State, payload: Tickets[]) {
    state.tickets = payload
  },
  setServices(state: State, payload: Tickets[]) {
    state.services = payload
  },
  setPromo(state: State, payload: any[]) {
    state.promo = payload
  },
}

const actions: ActionTree<State, RootState> = {
}

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions
}
